import { EMAIL_REGEX } from './constants';

const validateEmail = email => EMAIL_REGEX.test(String(email).toLowerCase());

export default validateEmail;
